export default "__VITE_ASSET__D153w3Gf__"